
import React from 'react';
import { connect } from 'dva';

import { component_tool } from '@/tool';
import { InputNumber, Form } from 'antd';
import { WizTableForm } from '@/containers/common';

let {
    WizTable
} = component_tool

const apiTypePathStage = WizTableForm.Config.stageScoreRule(this, { apiParams: { state: 2 } })
const path = WizTableForm.Config.path(this, { apiParams: { state: 2 } })

// 用于渲染阶段任务的table参数
let tableColumns = (form) => {
    let { getFieldDecorator } = form
    return [
        {
            title: '任务名称',
            dataIndex: 'entityName',
            key: 'entityName',
        },
        {
            title: '任务占比',
            dataIndex: 'taskRatio',
            key: 'taskRatio',
            width: 200,
            render: (text, record) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    {
                        getFieldDecorator(`item-${record.entityId}`, {
                            initialValue: record.taskRatio || 0,
                            rules: [{
                                required: true,
                                message: `请配置任务占比`
                            }]
                        })(
                            <InputNumber
                                min={0}
                                max={100}
                                formatter={value => `${value}%`}
                                parser={value => value.replace('%', '')}
                            />
                        )
                    }
                </Form.Item>
            ),
        },
    ]
}


let columns = (_self) => {
    let initVal = _self.initialValue
    return [
        {
            formItem: {
                type: 'hidden',
                initialValue: initVal && initVal.id
            },
            name: 'id'
        },
        {
            title: '培训路径',
            name: 'pathId',
            formItem: {
                ...path,
                diy: WizTableForm,
                disabled: initVal.id ? true : false,
                initialValue: initVal.pathId && initVal.pathId,
                initRows: initVal.pathId ? [{ id: initVal.pathId, name: initVal.pathName }] : [],
                selectType: 'radio',
                rules: [{
                    required: true,
                    message: '请选择路径'
                }],
                onSubmit: ({ value }) => {
                    trainPathId = value
                }
            }
        },
        {
            title: '路径阶段',
            name: 'entityId',
            formItem: {
                ...apiTypePathStage,
                diy: WizTableForm,
                links: { 'pathId': '路径' },
                linksKeyFormat: { pathId: 'trainPathId' },
                disabled: initVal.id ? true : false,
                initialValue: initVal.entityId && initVal.entityId,
                initRows: initVal.entityId ? [{ id: initVal.entityId, name: initVal.entityName }] : [],
                selectType: 'radio',
                rules: [{
                    required: true,
                    message: '请选择阶段'
                }],
                onSubmit: ({ valueRows }) => {
                    let { taskList = [] } = valueRows[0]
                    initVal.trainPathTaskScoreRules = taskList.length ? taskList.map(item => {
                        return {
                            id: '', // 修改时此处取列表id, 新增时不传
                            entityId: item.id,
                            entityName: item.entityName,
                        }
                    }) : []
                }
            },
        },
        {
            title: '阶段任务',
            name: 'trainPathStageScoreRuleCmds',
            formItem: {
                type: 'custom',
                render: (record, form) => {
                    let list = initVal.trainPathTaskScoreRules
                    let { getFieldValue } = form
                    let entityId = getFieldValue('entityId') // 用于重置表单时重载
                    /**
                     * 任务条目渲染流程
                     * 1、阶段选择后将taskList 加入到数据集trainPathTaskScoreRules参数中,
                     * 2、trainPathTaskScoreRules 每条只取三个值 id\entityName\entityId
                     * 3、阶段的条目渲染是根据 item-entityId , 拼参最后的整合参考index中的save
                     */
                    return (
                        list && list.length && entityId ?
                            <WizTable rowKey='entityId' className='path-table' pagination={false} columns={tableColumns(form)} dataSource={list} />
                            :
                            null
                    )
                }
            },
        }
    ]
}


export { columns }
